import React from 'react';
import { Image, Pressable, View } from 'react-native';

import Text from '../../components/text/Text';
import { SecondaryButton, Tag } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

/**
 * One photo of the visit: thumbnail (opens the viewer), its comment or "Add
 * comment". Photos still in the offline queue pass `syncTag` ({ label, tone })
 * and no comment action.
 */
const MediaListItem = ({
	item: media,
	customProps,
	index,
	syncTag,
}) => {
	const styles = useThemedStyles(createStyles);
	const canOpen = index !== undefined && Boolean(customProps?.setCurrentPhotoIndex);

	return (
		<View style={styles.row}>
			<Pressable
				onPress={canOpen ? () => customProps.setCurrentPhotoIndex(index) : undefined}
				disabled={!canOpen}
				accessibilityRole={canOpen ? 'imagebutton' : 'image'}
				accessibilityLabel={media.comment ? `Photo: ${media.comment}` : 'Photo'}
			>
				<Image
					// Force a remount when the image source changes to avoid recycled image flashes.
					key={media.link || media.id}
					style={styles.thumbnail}
					source={{ uri: media.link }}
				/>
			</Pressable>
			<View style={styles.body}>
				{Boolean(syncTag) && <Tag {...syncTag} />}
				{Boolean(media.comment) && <Text style={styles.comment}>{media.comment}</Text>}
				{!media.comment && !syncTag && Boolean(customProps?.onClickAddComment) && (
					<SecondaryButton label="Add comment" onPress={() => customProps.onClickAddComment(media)} style={styles.button} />
				)}
			</View>
		</View>
	);
};

const createStyles = ({ ui: { colors, radius, space, type } }) => ({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.md,
		padding: space.sm,
		borderRadius: radius.card,
		backgroundColor: colors.card,
	},
	thumbnail: {
		width: 72,
		height: 72,
		borderRadius: radius.chip,
		backgroundColor: colors.raised,
		resizeMode: 'cover',
	},
	body: {
		flex: 1,
		gap: space.xs,
		alignItems: 'flex-start',
	},
	comment: {
		...type.bodySmall,
		color: colors.text,
	},
	button: {
		alignSelf: 'flex-start',
	},
});

export default MediaListItem;
